import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { SharedService } from '../../services/shared.service'
import { HttpService } from '../../services/http.service'
import { MessageDialogComponent } from '../../dialogs/message-dialog/message-dialog.component'
import { SpinnerDialogComponent } from '../../dialogs/spinner-dialog/spinner-dialog.component'

@Component({
	selector: 'app-imei-with-email',
	templateUrl: './imei-with-email.component.html',
	styleUrls: ['./imei-with-email.component.css']
})
export class ImeiWithEmailComponent {
	isValidInput: boolean = false
	isRecaptcharRestart: boolean = false
	isRecaptchaSuccess: boolean = false
	isInvalidSerial: boolean = false
	isInvalidPolicy: boolean = false
	siteKey: string
	form: FormGroup
	spinner: MatDialogRef<SpinnerDialogComponent>

	constructor(
		private shared: SharedService,
		private http: HttpService,
		private formBuilder: FormBuilder,
		private router: Router,
		private dialog: MatDialog,
	) {
		this.shared.blockRefresh()
		this.siteKey = this.shared.recaptchaSiteKey
		this.isRecaptchaSuccess = this.shared.isRecaptchaSuccess
		this.form = this.formBuilder.group({
			serialNumber: [
				'',
				// Validators.required
			],
			policyNumber: [
				this.shared.policyNumber,
				// Validators.required
			],
			emailOne: [
				this.shared.email, [
					Validators.required,
					Validators.email,
					Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
					Validators.maxLength(100)
				]
			],
			recaptcha: [
				'',
				Validators.required
			]
		})
	}

	keyPressNumbersOnly(event: any) {
		this.shared.keyPressNumbersOnly(event)
  }

	onRecatcharSuccess(e: any): void {
		this.isRecaptchaSuccess = true
	}

	onRecaptchaExpired(): void {
		this.isRecaptcharRestart = true
		let interval = setInterval(() => {
			this.isRecaptchaSuccess = false
			this.isRecaptcharRestart = false
			clearInterval(interval)
		}, 100)
	}

	onNext(): void {
		this.spinner = this.dialog.open(SpinnerDialogComponent, {
			panelClass: 'transparent',
			disableClose: true
		})
		if (this.form.value.serialNumber) {
			const serialNumber = <string>this.form.value.serialNumber.toUpperCase()
			this.http.getProductsWithSerialNumber(serialNumber, this.form.value.emailOne)
				.subscribe((response) => {
					this.spinner.close()
					console.log(response)
					if (response.success) {
						this.isValidInput = true
						this.isInvalidSerial = false
						this.isInvalidPolicy = false
						this.shared.contract = response.data.contractStatusInfoResponse
					} else {
						this.isValidInput = false
						this.isInvalidSerial = true
						this.dialog.open(
							MessageDialogComponent, {
							data: {
								title: '',
								description: response.meta.error_message,
								button: 'Close'
							}
						})
					}
					this.router.navigateByUrl('/user-info')
				}, (error) => {
					this.spinner.close()
					this.dialog.open(
						MessageDialogComponent, {
						data: {
							title: '',
							description: error.message,
							button: 'Close'
						}
					})
				})
		} else {
			this.http.getProductsWithPolicyNumber(this.form.value.policyNumber, this.form.value.emailOne)
				.subscribe(response => {
					this.spinner.close()
					console.log(response)
					if (response.success) {
						this.isValidInput = true
						this.isInvalidSerial = false
						this.isInvalidPolicy = false
						this.shared.contract = response.data.contractStatusInfoResponse
					} else {
						this.isValidInput = false
						this.isInvalidPolicy = true
						this.dialog.open(
							MessageDialogComponent, {
							data: {
								title: '',
								description: response.meta.error_message,
								button: 'Close'
							}
						})
					}
					this.router.navigateByUrl('/user-info')
				}, (error) => {
					this.spinner.close()
					this.dialog.open(
						MessageDialogComponent, {
						data: {
							title: '',
							description: error.message,
							button: 'Close'
						}
					})
				})
		}

	}
}
